import React, { useState } from 'react';
import { Container, StepDesc, StepRow } from './GstSteps.styles';

const GstSteps = ({ data }) => {
    const [selected, setSelected] = useState(0);

    const handleEnter = (idx) => setSelected(idx);

    return (
        <Container>
            {
                data.map((item, index) => (
                    <StepRow key={item.id} selected={selected === index}>
                        {item.title && <h4 onMouseEnter={() => handleEnter(index)}><span className='count'>{index + 1}</span> <span className='title'>{item.title}</span></h4>}
                        {
                            selected === index &&
                            <React.Fragment>
                                {item.description && <StepDesc>{item.description}</StepDesc>}
                            </React.Fragment>
                        }
                    </StepRow>
                ))
            }
        </Container>
    )
}

export default GstSteps;